export default {
  'meta': {
    'langName': 'ITALIAN',
    'lang': 'Italiano'
  },
  'title': 'RICHIAMO PRODOTTO: Monopattino elettrico a marchio BTWIN (modello SD500E o MD500E)',
  'description': 'Gentile cliente,\n\ngrazie per aver acquistato un monopattino elettrico BTWIN SD 500E o MD500E.\n\nLa tua sicurezza è la nostra priorità; ti invitiamo a leggere attentamente le seguenti informazioni.\n\nNonostante le rigorose procedure di controllo qualità, abbiamo riscontrato un difetto di sicurezza nei monopattini elettrici BTWIN SD500E e MD500E. Un utilizzo intensivo può causare la formazione di una crepa nel punto di giunzione tra il telaio e il piantone. Tale difetto potrebbe portare alla rottura della giunzione, comportando il rischio di caduta per l\'utilizzatore.\n\nTi invitiamo a rispondere alle seguenti domande, affinché possiamo fornirti una soluzione per garantire la sicurezza del tuo prodotto.\n\nCi scusiamo per l\'inconveniente e ti ringraziamo per la fiducia accordataci.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Innanzitutto, può confermare il suo indirizzo email e il suo paese di residenza?'
  },
  'fields': {
    'country': 'Paese',
    'address': 'Indirizzo email',
    'email': 'Indirizzo email',
    'phonePrefix': 'Prefisso',
    'phone': 'Numero di telefono',
    'validations': {
      'phoneOrEmail': 'Si prega di fornire almeno un indirizzo e-mail o un numero di telefono',
      'email': 'Si prega di fornire un indirizzo e-mail valido',
      'phone': 'Si prega di fornire un numero di telefono valido',
      'selectAddress': 'Si prega di selezionare un indirizzo completo dall\'elenco (numero civico, via e città).',
      'incompleteAddress': 'L\'indirizzo deve includere numero civico, via e città. Inserisci almeno il numero civico e il nome della via, quindi seleziona un suggerimento.'
    },
    'firstName': 'Cognomne',
    'lastName': 'Nome',
    'deliveryAddress': 'Indirizzo per la consegna del pacco',
    'additionalAddress': 'Dettagli aggiuntivi per l\'indirizzo di consegna',
    'city': 'Città',
    'zip': 'CAP',
    'readConfirmation': 'Ho verificato i miei recapiti, esaminato le informazioni e accetto di attenermi a quanto indicato.',
    'choose': 'Seleziona',
    'required': 'Questo campo è obbligatorio',
    'deliveryAddressHelp': 'Inserisci il numero civico e il nome della via, quindi seleziona un indirizzo completo dall\'elenco.',
    'streetOnlyHint': 'Aggiungi un numero civico'
  },
  'ownerCheck': {
    'title': 'Possiedi ancora uno o più monopattini elettrici BTWIN SD500E e MD500E?'
  },
  'yes': 'SI',
  'no': 'NO',
  'ownerChanged': {
    'title': 'Ha i contatti dell\'attuale proprietario del canestro?',
    'confirmation': 'Sig./Sig.ra\n\nGrazie per la sua partecipazione a questo processo di qualità.\n\nCi scusiamo per ogni eventuale disagio e la ringraziamo per la fiducia.\n\nDECATHLON'
  },
  'recall': {
    'title': 'ti preghiamo di comunicarci la quantità di monopattini elettrici BTWIN SD500E e MD500E.',
    'descriptionSd500': 'Monopattino elettrico SD500E',
    'descriptionEmd500e': 'Monopattino elettrico MD500E',
    'modelNumberHelp': 'Troverai il riferimento del modello (SD500E o MD500E) nella parte inferiore del monopattino, come mostrato qui.',
    'quantity': 'Quantità',
    'confirmation': 'Grazie per aver compilato questo modulo; la tua richiesta è stata registrata correttamente.\n\nTi comunicheremo, entro un massimo di 20 giorni, la data a partire dalla quale potrai effettuare la riparazione.\n\nBuona giornata.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Riparazione',
    'description': 'Ti chiediamo di sospenderne l\'utilizzo.\n\nRiceverai a casa un kit di riparazione e le relative istruzioni per mettere in sicurezza il tuo monopattino. Il kit sarà fornito gratuitamente e l\'installazione è semplice e rapida.\n\nUna volta ricevuti i dati, ti contatteremo entro un massimo di 20 giorni per comunicarti la disponibilità del kit. Ti assicuriamo che faremo tutto il possibile per ridurre al minimo i tempi di attesa e garantire la tua soddisfazione.',
    'videoLink': 'Link al video',
    'store': 'Link istruzioni',
    'kitLabel': 'Kit di riparazione completo',
    'docLabel': 'Istruzioni per la riparazione',
    'callToAction': 'Clicca qui per ricevere gratuitamente il kit di riparazione.',
    'infoConfirmation': 'Grazie di verificare le informazioni',
    'validateConfirmation': 'Conferma',
    'backConfirmation': 'Indietro'
  },
  'repairRequest': {
    'title': 'Inserisci le seguenti informazioni per ricevere il kit di riparazione:'
  },
  'form': {
    'submit': 'Successivo'
  },
  'status': 'Translation validated by COUNTRY'
} as const
